import { Result } from '@bfe/moly';
import Modal from '../Modal';
import { useFm } from '@web3/base-hooks';
import { taskDetail } from '@/types';

type IVerifyResult = {
  taskVerifyObject: taskDetail;
  visible: boolean;
  result?: boolean;
  onOk: () => void;
  onCancel: () => void;
};

export function VerifyResult(props: IVerifyResult) {
  const { taskVerifyObject, result, visible } = props;
  const taskRuleConfig =
    (taskVerifyObject?.taskRuleConfig &&
      JSON.parse(taskVerifyObject?.taskRuleConfig)) ||
    {};
  const fm = useFm();
  const okText = result ? fm('word_ok') : fm('i_know');
  const title = result ? fm('verificationPassed') : fm('verificationFailed');
  const subTitle = result
    ? fm('congratsAllTasksCompleted')
    : taskRuleConfig?.dailyTask
      ? fm('verificationFailed_swap')
      : fm('completeTasksVerifyLater');
  return (
    <Modal
      visible={visible}
      size="small"
      okText={okText}
      cancelText={false}
      onOk={props.onOk}
      onCancel={props.onCancel}
    >
      <Result
        title={title}
        subTitle={subTitle}
        status={result ? 'success' : 'error'}
      ></Result>
    </Modal>
  );
}
